export default "__VITE_PUBLIC_ASSET__c9dde60e__"